const isMobile = window.innerWidth < 1024;

const unsetVariants = () => {
  const variants = document.querySelectorAll(".io-0006-modal .product-variant");
  variants.forEach((variant) => {
    const value = variant.querySelector(".product-variant__name-value");
    value.innerText = "";

    const input = variant.querySelector('input[type="radio"]');
    input.removeAttribute("checked");
  });
};

const addVariantListeners = () => {
  const variants = document.querySelectorAll(".io-0006-modal product-variants");
  variants.forEach((variant) => {
    const value = variant.querySelector(".product-variant__name-value");
    const labels = variant.querySelectorAll(
      ".product-variant__item:not(.product-variant__item--disabled) label",
    );

    labels.forEach((label) =>
      label.addEventListener("click", (e) => {
        const input = document.getElementById(label.getAttribute("for"));
        variant.classList.add("active");

        if (input.checked) {
          e.preventDefault();
          input.checked = false;

          //Remove label
          value.innerText = "";

          variant.classList.remove("active");
        }

        toggleButton();
      }),
    );
  });
};

const addSizeGuideListeners = () => {
  const variants = document.querySelectorAll(
    '.io-0006-modal .product-variant[data-type="size"] .product-variant__name',
  );

  variants.forEach((variant) => {
    const div = document.createElement("div");
    div.classList.add("ks-calculator-container", "sizing-calculator-container");
    div.innerHTML = `
        <button class="btn ks-calculator-modal-button sizing-calculator-modal-button">
          <span class="with-icon">
            <img class="kiwi-svg kiwi-injectable" src="https://cdn.kiwisizing.com/icons/tape4.min.svg?v=5-inject2" crossorigin="Anonymous" alt="injectable-icon">
            <span class="_ks_text">Finde meine Größe</span>
          </span>
        </button>`;

    variant.append(div);
  });

  const sizes = document.querySelectorAll(
    ".io-0006-modal .ks-calculator-modal-button",
  );
  sizes.forEach((button) =>
    button.addEventListener("click", (e) => {
      const target = document.querySelector(
        ".product--section .ks-calculator-modal-button",
      );
      target.click();
    }),
  );
};

const openPopup = (id) => {
  const popup = document.querySelector(`#io-0006-modal-${id}`);
  popup.style.display = "flex";
  popup.classList.add("open");
  const elementToInject = document.getElementById("kiwi-sizing-placeholder");

  if (popup.hasAttribute("data-inited-sizes")) {
    console.warn("Sizechar already initialized");
    return;
  }

  let successIndex = 0;
  popup.querySelectorAll("[data-sizing-id]").forEach((item, productIndex) => {
    let sizeChartID = item.getAttribute("data-sizing-id");

    try {
      let productData = JSON.parse(item.getAttribute("data-product-json"));
      if (sizeChartID && productData) {
        window.ks.loadSizing({
          productData: {
            productID: productData.id,
            title: productData.title,
            images: productData.images,
            tags: productData.tags,
            type: productData.type,
            collections: item.getAttribute("data-collections"),
          },
          options: {
            el: elementToInject,
            injectionSelector: `#${item.getAttribute("id")}`,
            injectionOrder: 3,
            displayMode: 1,
            layoutType: 0,
          },
          loaded: function (success) {
            item.addEventListener("click", () => {
              let charts = document.querySelectorAll(
                "#kiwi-sizing-placeholder > *",
              );
              let myChartContainer = charts[successIndex];
              let myChart = myChartContainer.querySelector("div");

              let tempModal = document.getElementById(myChart.getAttribute("id"));

              window._ks_modal.open(`#${myChart.getAttribute("id")}`);

              document.querySelector(".kiwi-sizing-modal.modal-style-0 .ks-modal-tab").click();

              successIndex++;
            });
          },
        });
      }
    } catch (e) {
      console.error(e);
      return;
    }

    popup.setAttribute("data-inited-sizes", true);
  });
};

const closePopups = () => {
  const popups = document.querySelectorAll(".io-0006-modal");
  popups.forEach((popup) => {
    popup.style.display = "none";
    popup.classList.remove("open");
  });
};

const addToCart = async (products) => {
  const formData = {
    items: products,
  };

  let result = await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });

  //Fire up the Fetch
  if (!result.ok) {
    throw new Error(result);
  }
};

const addToCartListeners = () => {
  const buttons = document.querySelectorAll(
    '.io-0006-modal button[type="submit"]',
  );
  buttons.forEach((button) =>
    button.addEventListener("click", async (e) => {
      e.preventDefault();

      const products = Array.from(
        document.querySelectorAll(
          '.io-0006-modal product-variants.active + .add-to-cart input[name="id"]',
        ),
      );
      const data = products.map((input) => {
        return {
          id: input.value,
          quantity: 1,
        };
      });

      await addToCart(data);

      //Close Popup
      closePopups();

      //Update Cart
      window.refreshCart();
    }),
  );
};

const toggleButton = () => {
  //Update Button
  const buttons = document.querySelectorAll(
    '.io-0006-modal button[type="submit"]',
  );
  const inputs = Array.from(
    document.querySelectorAll(".io-0006-modal product-variants.active"),
  );
  if (inputs.length) {
    buttons.forEach((button) => button.removeAttribute("disabled"));
  } else {
    buttons.forEach((button) => (button.disabled = true));
  }
};

const onClick = () => {
  const top = document.querySelectorAll(".io-0006-toggle-0");
  top.forEach((target) =>
    target.addEventListener("click", (e) => {
      e.preventDefault();

      openPopup("0");
    }),
  );

  const bottom = document.querySelectorAll(".io-0006-toggle-1");
  bottom.forEach((target) =>
    target.addEventListener("click", (e) => {
      e.preventDefault();

      openPopup("1");
    }),
  );

  const closes = document.querySelectorAll(".io-0006-modal [data-js-close]");
  closes.forEach((close) =>
    close.addEventListener("click", () => closePopups()),
  );
};

const moveProductVariants = () => {
  if (!isMobile) {
    return;
  }

  const variants = document.querySelectorAll(".io-0006-modal .popup-product");
  variants.forEach((variant) => {
    const target = variant.querySelector(".popup-product-details");
    const productVariant = variant.querySelector("product-variants");
    const addToCart = variant.querySelector(".add-to-cart");

    target.after(addToCart);
    target.after(productVariant);
  });
};

const addButtons = () => {
  const labels = ["Jetzt Konfigurieren", "Jetzt Hinzufügen"];
  const targets = document.querySelectorAll(
    ".io-0002-slide.other-models, .smi-related-products-1 .smi-section__inner",
  );
  targets.forEach((target, index) => {
    const button = document.createElement("button");
    button.classList.add("io-0006-toggle", `io-0006-toggle-${index}`);
    button.innerText = labels[index] ? labels[index] : "Jetzt ansehen";

    target.append(button);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  unsetVariants();

  addVariantListeners();

  addToCartListeners();

  onClick();

  moveProductVariants();
});
